import { registerControllers } from "stimulus-vite-helpers";
import { stimulus } from "~/init";

const controllers = import.meta.glob("./**/*_controller.js", { eager: true });
registerControllers(stimulus, controllers);
